var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mdi mdi-file-export-outline export-csv",attrs:{"title":_vm.getNameByKey('exportCSV')},on:{"click":_vm.exportCSVFile}})}
var staticRenderFns = []

export { render, staticRenderFns }